import { WorkTaskFilterCriteria } from 'api-client';
import { WorkTaskPriority } from '@planitgeo/treeplotter-domain/lib/modules/work/work-task/domain/work-task.interface';

export interface WorkTaskFilters {
  status?: ('open' | 'completed')[];
  assignee?: string;
  taskType?: string[];
  priority?: WorkTaskPriority[];
  workOrderName?: string[];
}

/** Shared so the row query and the count query cannot drift apart. */
export function buildWorkTaskFilterCriteria(
  filters?: WorkTaskFilters
): WorkTaskFilterCriteria | undefined {
  if (!filters) {
    return undefined;
  }

  const serverFilters: Array<{ field: string; values: string[] }> = [];

  if (filters.status && filters.status.length > 0) {
    serverFilters.push({
      field: 'status',
      values: filters.status.map((s) => (s === 'open' ? 'Open' : 'Completed')),
    });
  }

  if (filters.assignee && filters.assignee !== 'all') {
    serverFilters.push({ field: 'assigned_to', values: [filters.assignee] });
  }

  if (filters.taskType && filters.taskType.length > 0) {
    serverFilters.push({ field: 'task_type', values: filters.taskType });
  }

  if (filters.priority && filters.priority.length > 0) {
    serverFilters.push({ field: 'priority', values: filters.priority });
  }

  if (filters.workOrderName && filters.workOrderName.length > 0) {
    serverFilters.push({ field: 'work_order_name', values: filters.workOrderName });
  }

  return serverFilters.length > 0 ? { filters: serverFilters } : undefined;
}
